import {$, w} from './constants';
import './carousel';
import './faq-card';

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');

    const mobileMenuToggle = $('.mobile-menu-toggle');
    const mobileMenu = $('.header-menu-mobile');
    const body = $('body');

    if (mobileMenuToggle.length && mobileMenu.length) {
        mobileMenuToggle.on('click', function() {
            const isActive = mobileMenu.hasClass('is-active');
            
            mobileMenu.toggleClass('is-active');
            
            mobileMenuToggle.attr('aria-expanded', !isActive);
            
            if (!isActive) {
                body.css('overflow', 'hidden');
            } else {
                body.css('overflow', '');
            }
        });

        $(document).on('click', function(e) {
            if (mobileMenu.hasClass('is-active')) {
                if (!$(e.target).closest('.header-menu-mobile, .mobile-menu-toggle').length) {
                    mobileMenu.removeClass('is-active');
                    mobileMenuToggle.attr('aria-expanded', 'false');
                    body.css('overflow', '');
                }
            }
        });

        $(window).on('resize', function() {
            if ($(window).width() >= 1024) {
                if (mobileMenu.hasClass('is-active')) {
                    mobileMenu.removeClass('is-active');
                    mobileMenuToggle.attr('aria-expanded', 'false');
                    body.css('overflow', '');
                }
            }
        });
    }

    const nosotrosInstructorsExpandBtn = $('.nosotros-instructors-expand-btn');
    if (nosotrosInstructorsExpandBtn.length) {
        nosotrosInstructorsExpandBtn.on('click', function() {
            const sectionId = $(this).data('section-id');
            const section = $('#' + sectionId);
            
            if (section.length) {
                section.addClass('expanded');
                
                setTimeout(() => {
                    const hiddenCards = section.find('.nosotros-instructors-hidden');
                    hiddenCards.each(function(index) {
                        const card = $(this);
                        setTimeout(() => {
                            card.css({
                                'display': 'block',
                                'opacity': '1',
                                'transform': 'translateY(0)'
                            });
                        }, index * 50);
                    });
                }, 10);
            }
        });
    }
});
